import React from 'react';
import Section from './Section';

const RevistaInovaAgro = () => {
  const linkRevista = 'https://online.fliphtml5.com/Revista-Inova-Agro/revista-inova-agro/';

  const paragrafos = [
    'Esta publicação reúne parte dos temas, reflexões e experiências apresentados no Inova Agro, o I Congresso de Agronomia na AgroCapital, realizado pela Associação dos Engenheiros Agrônomos de Goiás (AEAGO). Pensada para fazer o conhecimento circular para além dos dias do evento, a revista amplia o alcance de discussões fundamentais para o agronegócio, um setor em constante transformação.',
    'Nas páginas a seguir, o leitor encontra conteúdos sobre inovação, tecnologia, sustentabilidade, gestão e novas ferramentas para o campo, além da valorização dos profissionais que transformam conhecimento em soluções para toda a cadeia produtiva.',
    'A edição é fruto da parceria com o Confea e a Mútua, por meio do programa Divulga Mútua, que apoia iniciativas de divulgação, capacitação e disseminação de conhecimento de interesse das profissões da engenharia, da agronomia e das geociências.',
    'Leia, compartilhe e continue o diálogo com quem esteve no Inova Agro e com quem não pôde participar.',
  ];

  return (
    <Section
      id="revista-inova-agro"
      bgClass="bg-gradient-to-b from-navy-dark via-navy to-navy-dark"
      title=""
      className="relative overflow-hidden"
    >
      <h2 className="sr-only">Revista Inova Agro</h2>

      {/* glow decorativo */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[320px] h-[320px] sm:w-[480px] sm:h-[480px] bg-gold/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-8 items-center">
        {/* Título */}
        <div className="text-center lg:text-left lg:col-start-1 lg:row-start-1">
          <span className="inline-block bg-gold text-navy text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-4">
            Nova publicação
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-white leading-snug">
            Revista Inova Agro – I Congresso de Agronomia na AgroCapital
          </h3>
        </div>

        {/* Capa flutuante */}
        <div className="flex justify-center lg:col-start-2 lg:row-start-1 lg:row-span-2">
          <a href={linkRevista} target="_blank" rel="noopener noreferrer" className="group block">
            <img
              src={process.env.PUBLIC_URL + '/imagem/capa-teste.jpeg'}
              alt="Capa da Revista Inova Agro"
              className="w-[220px] sm:w-[260px] md:w-[300px] rounded-lg shadow-[0_30px_60px_-15px_rgba(0,0,0,0.6)] animate-float transition-transform duration-500 group-hover:-translate-y-3 group-hover:scale-[1.02]"
            />
          </a>
        </div>

        {/* Descrição */}
        <div className="text-center lg:text-left lg:col-start-1 lg:row-start-2">
          <div className="space-y-4 text-white/80 leading-relaxed text-[15px]">
            {paragrafos.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <a
            href={linkRevista}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 bg-white text-navy py-2.5 px-7 rounded-full font-semibold hover:bg-gray-100 transition"
          >
            Folhear a revista
          </a>
        </div>
      </div>
    </Section>
  );
};

export default RevistaInovaAgro;
